import React from "react";
import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../store/userSlice";

const ProfilePage = () => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="p-2 md:p-4">

      {/* USER CARD */}
      <div className="bg-white rounded-2xl shadow p-4 md:p-6 flex items-center gap-4">

        <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-black text-white flex items-center justify-center text-lg font-bold">
          {user?.name?.charAt(0) || "U"}
        </div>

        <div>
          <h2 className="text-lg md:text-xl font-semibold">
            {user?.name}
          </h2>
          <p className="text-gray-500 text-sm">
            {user?.email}
          </p>
        </div>

      </div>

      {/* ACTION CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">

        <div
          onClick={() => navigate("/account/orders")}
          className="bg-white p-4 rounded-xl shadow hover:shadow-md cursor-pointer"
        >
          <h3 className="font-semibold">My Orders</h3>
          <p className="text-sm text-gray-500">
            Track your orders
          </p>
        </div>

        <div
          onClick={() => navigate("/account/address")}
          className="bg-white p-4 rounded-xl shadow hover:shadow-md cursor-pointer"
        >
          <h3 className="font-semibold">Addresses</h3>
          <p className="text-sm text-gray-500">
            Manage address
          </p>
        </div>

        <div className="bg-white p-4 rounded-xl shadow">
          <h3 className="font-semibold">Account Settings</h3>
          <p className="text-sm text-gray-500">
            Update profile
          </p>
        </div>

        <div
          onClick={handleLogout}
          className="bg-red-50 p-4 rounded-xl shadow cursor-pointer"
        >
          <h3 className="font-semibold text-red-600">
            Logout
          </h3>
        </div>

      </div>

    </div>
  );
};

export default ProfilePage;